import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { Filter } from '../models/filter.model';
import { Appointment } from '../models/appointment.model';

@Injectable({
    providedIn: 'root'
})
export class AppointmentService {

    constructor(private httpClient: HttpClient) { }

    getOne(id: Number) {
        return this.httpClient.get('api/appointments/' + id).toPromise();
    }

    gridView(filter: Filter) {
        return this.httpClient.post('api/appointments/gridview', filter.data)
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    getTotal(filter: Filter) {
        return this.httpClient.post('api/appointments/gridview', filter.data)
            .pipe(
                map((res: any) => {
                    return res.total;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    connetToOffer(appointmentId: Number, offerNumber: String) {
        return this.httpClient.post('api/appointments/connectoffer', { AppointmentID: appointmentId, OfferNumber: offerNumber }).toPromise();
    }

    createAppointment(appointment: Appointment) {
        return this.httpClient.post('api/appointments/create', appointment.data).toPromise();
    }

    editAppointment(id, comment, statusId) {
        return this.httpClient.post('api/appointments/updatestatus', { AppointmentID: id, AppointmentStatus: statusId, Comment: comment }).toPromise();
    }

    deleteAppointment(ids: Array<Number>) {
        return this.httpClient.post('api/appointments/delete', ids).toPromise();
    }

    changeStatus(id, status) {
        return this.httpClient.post('api/appointments/changevisibility', { IDs: [id], Visibility: status }).toPromise();
    }

    changeAssigner(id, userid) {
        return this.httpClient.post('api/appointments/assignuser', { AppointmentID: id, UserID: userid }).toPromise();
    }

    appointmentsExcel(filter: Filter) {
        return this.httpClient.post('api/appointments/excel', filter.data.Filter, { observe: 'response', responseType: 'blob' });
    }

}